import {
  Stack,
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  TableBody,
  Typography,
} from '@mui/material';
import clsx from 'clsx';
import { tableOptions } from './constants';
import { TableRowGeneral } from './TableRowGeneral';
import { CreativeWrapperStyled, TableStyled } from './styles';
import { Edit } from '../Upload/Edit';
import { useLibrary } from './hooks/useLibrary';

interface LibraryCreativeTableProps {
  onClose: () => void;
  isDisplay: boolean;
}

export const LibraryCreativeTable = ({
  onClose,
  isDisplay,
}: LibraryCreativeTableProps) => {
  const {
    library,
    columns,
    sort,
    drop,
    order,
    showDropzone,
    orderBy,
    search,
  } = useLibrary({ onClose });

  return (
    <CreativeWrapperStyled flex={1} spacing={5}>
      <Stack flex={1} spacing={4.25}>
        <TableStyled>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  width: 0,
                }}
              />
              {columns.map(column => (
                <TableCell
                  className={clsx({
                    sticky:
                      tableOptions.sticky.left.includes(column.id) ||
                      tableOptions.sticky.right.includes(column.id),
                    'sticky-left': tableOptions.sticky.left.includes(
                      column.id,
                    ),
                    'sticky-right': tableOptions.sticky.right.includes(
                      column.id,
                    ),
                  })}
                  sx={
                    (column as { headerSx?: Record<string, unknown> })
                      .headerSx
                  }
                  key={column.id}
                >
                  {column.sortable ? (
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : 'asc'}
                      onClick={e => {
                        sort(e, column);
                      }}
                    >
                      {column.label}
                    </TableSortLabel>
                  ) : (
                    column.label
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {library.map(row => (
              <TableRowGeneral
                key={row.id}
                item={row}
                columns={columns}
                search={search} // Use the search value from useLibrary
              />
            ))}
          </TableBody>
        </TableStyled>
        {!showDropzone && search && !library?.length && (
          <Stack flex={1} alignItems="center" justifyContent="center">
            <Typography
              data-testid="creative-search-no-match-message"
              variant="body2"
            >
              Your search - <b>{search}</b> - did not match any results
            </Typography>
          </Stack>
        )}
        {showDropzone && (
          <Edit flex={1} isDisplay={isDisplay} onDrop={drop}>
            <Typography
              data-testid="no-creatives-available-message"
              variant="body2"
            >
              No creatives in library
            </Typography>
          </Edit>
        )}
      </Stack>
    </CreativeWrapperStyled>
  );
};
